export const getLatestDayData = (items: any[], dateField: string): any[] => {
  if (!items?.length) {
    return [];
  }
  const latestDate = items.reduce((max, v) => (v[dateField] > max ? v[dateField] : max), '');
  return items.filter((v) => v[dateField] === latestDate);
}